import React, { useState, useEffect } from "react";
import {getIdData,addData,updateData} from "../../../lib/studentnotes"
import { useNavigate, useParams } from 'react-router-dom';
import TextEditor from "../../ui/editor";
import { useAuth } from "../../../usercontext";

export default function InstructorNotesEdit() {

  const [noteData, setNoteData] = useState("");
  const [title, setTitle] = useState("");
  const { profile } = useAuth();
  const [data, setData] = useState([]);

  const navigate = useNavigate();
  let { slug, Id , page} = useParams();

  const instructorId = profile.id;
  //const studentId = Id;
  //const studentClass = profile.class;
//console.log("Geldi",profile.id);

  async function GetData() {

    const noteData = await getIdData(Id);
    console.log("noteData",noteData);
    setData(noteData);
    setTitle(noteData[0].title);
    setNoteData(noteData[0].description);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

//console.log("title",title,noteData,studentId);

    if (slug === "Add") {
      console.log("Add");
      await addData({
        title: title,
        description: noteData,
        instructorId:instructorId,
        studentId: Id//,
        //lessonType:lessonType
      });

    }
    else {
      console.log("Update");
      await updateData({
        id: Id, //update de id kayıt id si
        title: title,
        description: noteData//,
        //lessonType:lessonType
      });
    }

    if (page==="Main")
      navigate("/instructor/instructor-notes");
    else
      navigate("/instructor/instructor-studentnotes/" + Id);

  };

  useEffect(() => {
    if (slug !== "Add") {
      GetData();
    }

  }, [slug])
  return (
    <div className="col-xl-9 col-md-8 mx-auto">
      <div className="settings-widget profile-details">
        <div className="settings-menu p-0">
          <div className="profile-heading">
            <h3>{slug === "Add" ? "Add Note" : "Update Note"}</h3>
          </div>
          <div className="checkout-form personal-address add-course-info ">
            <form role="form" onSubmit={handleSubmit}>
              <div className="row mx-auto">
                <div className="col-9">
                  <div className="form-group">
                    <label className="form-control-label">
                      Title
                    </label>
                    <input
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      className="form-control"
                      placeholder="Enter Title"
                      required
                    />
                  </div>
                </div>
                  <div className="form-group ">
                    <label className="form-control-label">
                      Description
                    </label>
                    <div id="editor" >
                      <TextEditor value = {noteData} setValue = {setNoteData}/>
                    </div>
                  </div>
                <div className="update-profile d-flex justify-content-between">
                  <button type="submit" className="btn btn-primary">
                    {slug === "Add" ? "Add Note" : "Update Note"}
                  </button>
                  <button onClick={() => navigate(-1)} className="btn btn-black btn-sm">
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
